import styled from "styled-components";

export const AccountParent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    background: #eeeeee;
`;


export const Wrapper = styled.div`
display: flex;
flex: 1;
border: 1px solid #eeeeee;
display: flex;
flex-direction: column;
background: #eeeeee;
height:100%;
       
`;




export const PersonalInformationParent = styled.section`
  width: 45%;
  height: 80vh;
  display: flex;
  border-radius: 12px;
  background:#ffffff;
  margin-top: 5rem;
  margin-left:1rem;
  border: 1px solid #fefefe;
`;

export const PersonalInfoWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 1rem;
`;

export const Heading = styled.h3`
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1rem;
  color: #1e1e1e;
  margin-left:1rem;

`;

export const PersonalInformationForm = styled.form`
  width: 100%;
  height: 100%;
  margin-left:1rem;
  
`;

export const DivideWrapper = styled.div`
  display: flex;
  width: 80%;
  gap: 1rem;
  margin-top: 1rem;
`;

export const Side = styled.div`
  width: 50%;
`;

export const NavigateButton = styled.button`
  margin-top: 1rem;
  background: #0570fb;
  border-radius: 4px;
  padding: 12px 32px;
  width: 25.7rem;
  height: 4.8rem;
  color: #fff;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 24px;
`;

export const NavBarContainer = styled.div`
    width: 100%;
    height: 10%;
    background: #fff;
    display: flex;
    
`;